<div class="container pt-5 pb-5">

  <router-outlet></router-outlet>

</div>

<div class="footer bg-primary text-white fixed-bottom mt-5">
  Hematologicko-transfuzní oddělení | Městská nemocnice Čáslav | <a class="text-white text-decoration-none" href="/page/privacy-policy"> Zpracování osobních údajů</a>
</div>
